import Cookies from "js-cookie"
import { httpAuthAxios } from "@/api/request"
import Vue from 'vue'

const user = {
  namespaced: true,
  state: () => ({
    token: Cookies.get("Dealer-User-Token"),
    profile: JSON.parse(localStorage.getItem("dealer_profile")),
    loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    // 门店所在地
    dealerLocation: {
      province: "",
      city: "",
      county: ""
    },
    // 门店省
    dealerProvinceData: [],
    /** start 存一份数据在store，后续逐步替换存在localStorage的值 */
    userIsAdmin: '',
    userProfile: '',
    userLoginInfo: '',
    userBaseInfo: '',
    /** end */
    dccTip: JSON.parse(localStorage.getItem("dccTip"))  || {}
  }),
  mutations: {
    updateUserState(state, payload) {
      for (let key in payload) {
        state[key] = payload[key]
      }
    },
    updateDccTip(state, payload) {
      // 记录当前设备登录所有用户是否关闭dcc线索清洗提示
      for (let key in payload) {
        Vue.set(state.dccTip, key, payload[key])
      }
      localStorage.setItem("dccTip", JSON.stringify(state.dccTip));
    }
  },
  actions: {
    setDccTip({ commit, state }, payload) {
      commit("updateDccTip", payload)
    },
    setAdmin({ commit }, payload) {
      commit("updateUserState", { userIsAdmin: payload })
    },
    setDealer({ commit }, payload) {
      commit("updateUserState", { profile: payload })
    },
    setLoginInfo({ commit }, payload) {
      commit("updateUserState", { userLoginInfo: payload })
    },
    setBaseInfo({ commit }, payload) {
      commit("updateUserState", { userBaseInfo: payload })
    },
    getDealerRegion({ commit, getters, dispatch }, payload) {
      if (!!getters.dealerLocation.province&&getters.dealerProvinceData.length) {
        return new Promise((resolve) => {
          resolve({
            dealerLocation: getters.dealerLocation,
            dealerProvinceData: getters.dealerProvinceData
          })
        })
      }
      return dispatch("getRegionList", { isAll: true, ...payload }).then((res) => {
        const { province, city, county, data } = res ?? {}
        const result = {
          dealerLocation: { province, city, county },
          dealerProvinceData: data
        }
        commit("updateUserState", result)
      })
    },
    // 获取省市区
    getRegionList({ getters }, payload) {
      const { isAll=false, ...params } = payload
      return new Promise((resolve, reject) => {
        httpAuthAxios
          .post("/v2/appCustomerService/orderRegion", params)
          .then((res) => {
            if (isAll) {
              resolve(res?.data ?? {})
            } else {
              resolve(res?.data?.data ?? [])
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  getters: {
    dealerProvinceData: state => state.dealerProvinceData,
    dealerLocation: state => state.dealerLocation,
    token: state => state.token,
    profile: state => state.profile,
    loginInfo: state => state.loginInfo,
    dccTip: state => state.dccTip
  }
}

export default user
